import { useEffect, useState } from "react";
import SapServiceRetornoEntrega from "../../../services/resource/SapServiceRetornoEntrega";
import { CustomTable } from "../../../componentes/table/CustomTable";

function TabelaRetornosDeEntregas({ values }) {

    const retornoService = new SapServiceRetornoEntrega();

    const [loading, setLoading] = useState(false);
    const [listaRetornos, setListaRetornos] = useState([]);

    useEffect(() => {
        buscarRetornos();
    }, []);

    const buscarRetornos = () => {
        setLoading(true);
        retornoService.listar({
            filialId: values.filialId,
            transporte: values.transporte
        })
            .then(res => setListaRetornos(res.data))
            .finally(() => setLoading(false));
    };

    const columns = [
        { key: "dataEntrega", label: "DT. Entrega", format: "date" },
        { key: "dataRetorno", label: "DT. Retorno", format: "date" },
        { key: "transporte", label: "Transporte" },
        { key: "clienteCodigo", label: "Cliente Cód.", center: true },
        { key: "clienteRazaoSocial", label: "Razão Social" },
        { key: "clienteFantasia", label: "Cliente Fantasia" },
        { key: "clienteTipo", label: "Tipo Cliente", center: true },
        { key: "canal", label: "Canal" },
        { key: "produtoId", label: "Cód. Prod.", center: true },
        { key: "produtoNome", label: "Produto" },
        { key: "produtoCategoria", label: "Categoria" },
        { key: "notaFiscal", label: "Nota Fiscal" },
        { key: "motivoCodigo", label: "Motivo", center: true },
        { key: "motivoNome", label: "Descrição Retorno" },
        { key: "caixasFisicas", label: "Caixas Físicas", format: "number", center: true },
        { key: "caixasUnitarias", label: "Cx Unitárias", format: "number", center: true },
        { key: "cubos", label: "Cubos", format: "number", center: true },
        { key: "valorTotal", label: "Valor", format: "currency", className: "font-semibold" },
    ];

    const footer = (data) => {
        const totalCaixasFisicas = data.reduce((s, r) => s + (r.caixasFisicas || 0), 0);
        const totalCaixasUnitarias = data.reduce((s, r) => s + (r.caixasUnitarias || 0), 0);
        const totalValor = data.reduce((s, r) => s + (r.valorTotal || 0), 0);
        const totalCubos = data.reduce((s, r) => s + (r.cubos || 0), 0);

        return (
            <div style={{
                display: "flex",
                gap: 20,
                flexWrap: "wrap",
                fontSize: 13
            }}>
                <span><b>Cx Unitárias:</b> {totalCaixasUnitarias.toLocaleString("pt-BR")}</span>
                <span><b>Caixas Físicas:</b> {totalCaixasFisicas.toLocaleString("pt-BR")}</span>
                <span><b>Cubos:</b> {totalCubos.toLocaleString("pt-BR")}</span>
                <span><b>Valor:</b> {totalValor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>
            </div>
        );
    };

    return (
            <CustomTable
                data={listaRetornos}
                columns={columns}
                loading={loading}
                maxHeight={300}
                showHeader={false}
                className="text-[11px]"
                footer={footer}
                exportable
            />       
    );
}

export default TabelaRetornosDeEntregas;
